import script from "./AgregarModificar.vue?vue&type=script&setup=true&lang=js"
export * from "./AgregarModificar.vue?vue&type=script&setup=true&lang=js"

import "./AgregarModificar.vue?vue&type=style&index=0&id=eb7c9c32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb7c9c32"]])

export default __exports__